import merge from 'lodash/merge';

export const shadeColor = (percent, userColor) => {
  let color = userColor || '#333333';
  var R = parseInt(color.substring(1, 3), 16);
  var G = parseInt(color.substring(3, 5), 16);
  var B = parseInt(color.substring(5, 7), 16);

  R = parseInt(String((R * (100 + percent)) / 100));
  G = parseInt(String((G * (100 + percent)) / 100));
  B = parseInt(String((B * (100 + percent)) / 100));

  R = R < 255 ? R : 255;
  G = G < 255 ? G : 255;
  B = B < 255 ? B : 255;

  var RR = R.toString(16).length === 1 ? `0${R.toString(16)}` : R.toString(16);
  var GG = G.toString(16).length === 1 ? `0${G.toString(16)}` : G.toString(16);
  var BB = B.toString(16).length === 1 ? `0${B.toString(16)}` : B.toString(16);

  return `#${RR}${GG}${BB}`;
};

function generateAnnotation(settings, max) {
  let sign = settings.value / max > 0.4 ? 1 : -1;
  return {
    type: 'line',
    id: `BTV${settings.value}`,
    mode: 'horizontal',
    display: true,
    scaleID: 'y-axis-0',
    borderColor: settings.color1 || 'grey',
    borderDash: [5, 5],
    borderWidth: 0.5,
    value: settings.value,
    label: {
      content: settings.label,
      enabled: true,
      position: 'top',
      backgroundColor: settings.color2 || '#7b7b7bba',
      xAdjust: settings.labelPadding || null,
      yAdjust: 7 * sign,
      fontSize: 10,
    },
  };
}

function generateAnnotations(annotations, max) {
  return annotations
    .filter((annotation) => annotation.value)
    .map((annotation) => {
      return generateAnnotation(annotation, max);
    });
}

function chartOptions(customOptions) {
  let options = {
    responsive: true,
    maintainAspectRatio: false,
    legend: {
      fontSize: 10,
      boxWidth: 20,
      display: customOptions.legend === false ? false : true,
      position: customOptions.position || 'top',
    },
  };
  if (customOptions.annotations) {
    options.annotation = {
      drawTime: 'afterDraw',
      annotations: generateAnnotations(customOptions.annotations, customOptions.max || 1),
    };
    delete customOptions.annotations;
  }
  return merge(options, customOptions);
}

export default {
  data: function () {
    return {
      shadeColor,
      chartOptions,
    };
  },
  methods: {},
};
